import React from 'react';

export const CardTag = ({
  text = '',
  color = 'green',
}) => (
  <div className={`tag bg-${color}`}>
    <span>{text}</span>
  </div>
);
 
export default CardTag;
